import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsKachelIconGebaeude(props: SVGProps<SVGSVGElement>) {
  return <svg
    data-name="Ebene 1"
    id="MS_Klimadashboard_Icons_Kachel_Icon_Gebaeude_svg__Ebene_1"
    viewBox="0 0 73 52"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>
        {
          '.MS_Klimadashboard_Icons_Kachel_Icon_Gebaeude_svg__cls-1{fill:#9d9de6}'
        }
      </style>
    </defs>
    <path
      className="MS_Klimadashboard_Icons_Kachel_Icon_Gebaeude_svg__cls-1"
      d="M51.02 41.74c-.69 0-1.25-.56-1.25-1.25V22.93h-3.83c-.27 0-.54-.09-.76-.26l-9.07-6.9-8.8 6.59c-.21.16-.47.25-.74.25l-14.7.12c-.55 0-1.04-.36-1.2-.89-.16-.53.05-1.1.51-1.41l8.1-5.31v-7c0-.69.56-1.25 1.25-1.25h4.77c.69 0 1.25.56 1.25 1.25v2.08l8.67-6.89a1.26 1.26 0 0 1 1.51-.04L60.8 20.52c.44.31.63.88.46 1.39s-.64.87-1.18.88l-7.81.11v17.58c0 .69-.56 1.25-1.25 1.25Zm-4.66-21.32h4.66l5.23-.07L36.04 5.86l-9.95 7.91c-.38.3-.89.36-1.32.15-.43-.21-.71-.65-.71-1.13V9.37h-2.27v6.43c0 .42-.21.81-.57 1.05l-5.11 3.35 10.04-.08 9.23-6.91c.45-.33 1.06-.33 1.51 0l9.48 7.21Z"
    />
    <path
      className="MS_Klimadashboard_Icons_Kachel_Icon_Gebaeude_svg__cls-1"
      d="M52.71 48.32H20.05c-.69 0-1.25-.56-1.25-1.25V26.6a1.25 1.25 0 0 1 2.5 0v19.22h31.41a1.25 1.25 0 0 1 0 2.5Z"
    />
    <path
      className="MS_Klimadashboard_Icons_Kachel_Icon_Gebaeude_svg__cls-1"
      d="M35.03 41.38H26.8c-.69 0-1.25-.56-1.25-1.25V26.85c0-.69.56-1.25 1.25-1.25h8.16c.69 0 1.25.56 1.25 1.25v6.34a1.25 1.25 0 0 1-2.5 0V28.1h-5.66v10.78h6.98a1.25 1.25 0 0 1 0 2.5Z"
    />
  </svg>
}
export default SvgMsKlimadashboardIconsKachelIconGebaeude
